import { Editor } from "@tinymce/tinymce-react";
import { Button, Col, Divider, Row, Space, Spin } from "antd";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { addArticle } from "../../api/fire-article";
import { UserContext } from "../../auth/user-context";
import { useBlogState } from "./blog-page-hooks";
import "./blog-page.scss";
import BlogTags from "./blog-tag";

// const Editor = React.lazy(() => import('@tinymce/tinymce-react'))

export interface BlogPageProps {}

const BlogPage: React.FC<BlogPageProps> = () => {
  const history = useHistory();

  const { user } = useContext(UserContext);

  const {
    tags,
    content,
    title,
    id,
    isDraft,
    loading,
    handleEditorChange,
    handleTitleChange,
    pageType,
  } = useBlogState();

  if (loading) {
    return <Spin spinning size="large"></Spin>;
  }

  if (!loading) {
    return (
      <Row justify="center" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        {user ? (
          <Col xs={24} md={12} className="d-flex justify-content-end">
            <Space align="end">
              {isDraft ? (
                <Button
                  onClick={() =>
                    addArticle(
                      {
                        tags,
                        content,
                        title,
                        userId: user.uid,
                        userName: user.displayName,
                        userPhotoUrl: user.photoURL,
                        id,
                      },
                      true
                    ).then(() => {
                      history.push("/blogs");
                    })
                  }
                >
                  Save as Draft
                </Button>
              ) : null}
              <Button
                type="primary"
                onClick={() =>
                  addArticle(
                    {
                      tags,
                      content,
                      title,
                      userId: user.uid,
                      userName: user.displayName,
                      userPhotoUrl: user.photoURL,
                      id,
                    },
                    false
                  ).then(() => {
                    history.push("/blogs");
                  })
                }
              >
                Publish
              </Button>
            </Space>
          </Col>
        ) : null}
        <Col xs={24} md={14} className="yty-blog-title">
          <Editor
            initialValue={title}
            apiKey="xmx0qhr4m9psxy652cp8jyfrecaukppfw8i2108guy85r14l"
            init={{
              plugins: ["preview anchor hr pagebreak", "paste quickbars"],
              toolbar: false,
              menubar: false,
              inline: true,
              icons: "thin",
              placeholder: "Add your Title...",
              quickbars_insert_toolbar: false,
              fontsize_formats: "14pt 16pt 18pt 24pt 36pt",
            }}
            onEditorChange={handleTitleChange}
            disabled={pageType === "view"}
          />
        </Col>

        <Col xs={24} md={13} className="yty-blog-body">
          <Editor
            initialValue={content}
            apiKey="xmx0qhr4m9psxy652cp8jyfrecaukppfw8i2108guy85r14l"
            init={{
              body_class: "yty_editor",
              height: 500,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor hr pagebreak",
                "searchreplace visualblocks code fullscreen codesample",
                "insertdatetime media table paste code help wordcount quickbars",
              ],
              toolbar: false,
              menubar: false,
              inline: true,
              icons: "thin",
              placeholder: "Tell your story...",
              quickbars_selection_toolbar:
                "bold italic link | h1 h2 | outdent indent",
              quickbars_insert_toolbar:
                "quickimage bullist numlist media | hr | codesample image",
              fontsize_formats: "14pt 16pt 18pt 24pt 36pt 48pt",
              // content_style: "",
            }}
            onEditorChange={handleEditorChange}
            disabled={pageType === "view"}
          />
          <Divider>End</Divider>
        </Col>
        <BlogTags />
      </Row>
    );
  }
};
export default BlogPage;
